import StarBorderSharpIcon from "@mui/icons-material/StarBorderSharp";
import {
  Button,
  Chip,
  Grid,
  Typography,
  alpha,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Stack } from "@mui/system";
import { useRouter } from "../../../helper-functions/useRouterReplacement";
import React, { useState } from "react";
import { getAmountWithSign } from "../../../helper-functions/CardHelpers";
import { setDeliveryManInfoByDispatch } from "../../../redux/slices/searchFilter";
import {
  CustomPaperBigCard,
  CustomStackFullWidth,
  StoreImageBox,
} from "../../../styled-components/CustomStyles.style";
import CustomImageContainer from "../../CustomImageContainer";
import CustomFormatedDateTime from "../../date/CustomFormatedDateTime";
import TrackParcelOrderDrawer from "../../home/module-wise-components/parcel/TrackParcelOrderDrawer";
import TrackOrderDrawer from "../../home/module-wise-components/TrackOrderDrawer";
import trackOrderIcon1 from "../assets/Maskroup.svg";
import trackOrderIcon from "../assets/trackOrderIcon.png";
import { DateTypography, TrackOrderButton } from "../myorders.style";
export const CustomPaper = styled(CustomPaperBigCard)(({ theme }) => ({
  padding: "16px",
  backgroundColor: alpha(theme.palette.neutral[300], 0.4),
  boxShadow: "none",
  cursor: "pointer",
  borderRadius: "12px",
  marginBottom: "12px",
  transition: "all 0.2s ease-in-out",
  "&:hover": {
    backgroundColor: theme.palette.neutral[100],
    boxShadow: "0px 4px 16px rgba(88, 110, 125, 0.15)",
    transform: "translateY(-2px)",
  },
  [theme.breakpoints.down("md")]: {
    backgroundColor: theme.palette.neutral[100],
    boxShadow: "0px 2px 8px rgba(88, 110, 125, 0.1)",
    padding: "12px",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "16px 12px",
  },
}));
const OrderStatusTypography = styled(Typography)(({ theme, color }) => ({
  color: color,
  fontWeight: 600,
  fontSize: "14px",
  textTransform: "capitalize",
  [theme.breakpoints.down("md")]: {
    fontSize: "12px",
  },
}));

const Order = (props) => {
  const theme = useTheme();
  const { order, t, configData, dispatch } = props;

  const [sideDrawerOpen, setSideDrawerOpen] = useState(false);
  const [trackOrderDrawerOpen, setTrackOrderDrawerOpen] = useState(false);
  const [isTrackButtonHovered, setIsTrackButtonHovered] = useState(false);
  const isXSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const storeImage =
    order?.module_type === "parcel"
      ? configData?.base_urls?.parcel_category_image_url
      : configData?.base_urls?.store_image_url;
  const router = useRouter();

  const handleClick = (e) => {
    if (order?.delivery_man) {
      dispatch(setDeliveryManInfoByDispatch(order?.delivery_man));
    }
    if (order?.module_type === "parcel") {
      if (sideDrawerOpen) {
      } else {
        router.push({
          pathname: "/profile",
          query: {
            orderId: order?.id,
            page: "my-orders",
          },
        });
      }
    } else {
      router.push({
        pathname: "/profile",
        query: {
          orderId: order?.id,
          page: "my-orders",
        },
      });
    }
  };
  const handleRateButtonClick = (e) => {
    e.stopPropagation();
    router.push(`/rate-and-review/${order?.id}`, undefined, {
      shallow: true,
    });
  };
  const handleClickTrackOrder = (e) => {
    e.stopPropagation();
    if (order?.delivery_man) {
      e.stopPropagation();
      dispatch(setDeliveryManInfoByDispatch(order?.delivery_man));
    }
    if (order?.module_type === "parcel") {
      e.stopPropagation();
      setSideDrawerOpen(true);
    } else {
      // Open sidebar for regular orders
      e.stopPropagation();
      setTrackOrderDrawerOpen(true);
    }
  };
  const color = () => {
    if (
      order?.order_status === "pending" ||
      order?.order_status === "failed" ||
      order?.order_status === "canceled"
    ) {
      return alpha(theme.palette.error.main, 0.8);
    }
    if (
      order?.order_status === "confirmed" ||
      order?.order_status === "picked_up" ||
      order?.order_status === "delivered"
    ) {
      return theme.palette.primary.main;
    }
  };

  const deliveredInformation = () => (
    <>
      <Button
        onClick={(e) => handleRateButtonClick(e)}
        variant="outlined"
        startIcon={
          <StarBorderSharpIcon
            sx={{
              width: { xs: "19px", sm: "19px", md: "20px" },
              height: "23px",
              paddingBottom: "3px",
            }}
          />
        }
        sx={{
          p: {
            xs: "5px 10px 5px 10px",
            sm: "8px 15px 8px 15px",
            md: "7px 15px 7px 15px",
          },
          fontSize: {
            xs: "12px",
            sm: "12px",
            md: "14px",
          },
          "&:hover": {
            backgroundColor: (theme) => theme.palette.primary.dark,
            color: (theme) => theme.palette.whiteContainer.main,
          },
        }}
      >
        {t("Review")}
      </Button>
    </>
  );

  const notDeliveredInformation = () => (
    <>
      {order?.order_status !== "delivered" &&
        order?.order_status !== "failed" &&
        order?.order_status !== "canceled" &&
        order?.order_status !== "refund_requested" &&
        order?.order_status !== "refund_request_canceled" &&
        order?.order_status !== "refunded" && (
          <Stack
            flexWrap="wrap"
            paddingRight={{ xs: "0px", md: "20px" }}
            alignItems="center"
          >
            <TrackOrderButton
              variant="outlined"
              size="small"
              onClick={(e) => handleClickTrackOrder(e)}
              onMouseEnter={() => setIsTrackButtonHovered(true)}
              onMouseLeave={() => setIsTrackButtonHovered(false)}
              endIcon={
                <CustomImageContainer
                  src={isXSmall ? trackOrderIcon1.src : trackOrderIcon.src}
                  width="20px"
                  height="20px"
                  smWidth="15px"
                  smHeight="15px"
                  alt="icon"
                  sx={{
                    filter: isTrackButtonHovered ? 'brightness(0) invert(1)' : 'none',
                    transition: 'filter 0.3s ease'
                  }}
                />
              }
            >
              {t("Track Order")}
            </TrackOrderButton>
          </Stack>
        )}
    </>
  );
  return (
    <CustomPaper onClick={(e) => handleClick(e)}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={2} md={1}>
          <Stack direction={{ xs: "row", sm: "column" }} alignItems="center" spacing={1}>
            <StoreImageBox
              borderraduis="10px"
              padding="8px"
              border={`1px solid ${alpha(theme.palette.neutral[400], 0.2)}`}
              sx={{
                minWidth: { xs: "60px", sm: "70px" },
                width: { xs: "60px", sm: "70px" },
                height: { xs: "60px", sm: "70px" },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0
              }}
            >
              {order?.module_type === "parcel" && (
                <Stack
                  sx={{
                    position: "absolute",
                    top: "2px",
                    zIndex: 2,
                    left: "2px",
                  }}
                >
                  <Chip
                    label={order?.module_type}
                    color="primary"
                    size="small"
                    style={{
                      borderRadius: "2px",
                      textTransform: "capitalize",
                      fontSize: "10px",
                      height: "18px"
                    }}
                  />
                </Stack>
              )}

              <CustomImageContainer
                src={`${storeImage}/${
                  order?.module_type === "parcel"
                    ? order?.parcel_category?.image
                    : order?.store?.logo
                }`}
                width={{ xs: "50px", sm: "60px" }}
                height={{ xs: "50px", sm: "60px" }}
                objectfit="cover"
                borderRadius="6px"
              />
            </StoreImageBox>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={10} md={11}>
          <CustomStackFullWidth
            direction={{ xs: "column", md: "row" }}
            spacing={{ xs: 1, md: 2 }}
            alignItems={{ xs: "flex-start", md: "center" }}
            justifyContent="space-between"
            sx={{
              paddingLeft: { xs: "0px", md: "16px" },
              paddingTop: { xs: "8px", sm: "0px" },
              minHeight: { xs: "auto", sm: "70px" }
            }}
          >
            <Stack justifyContent="flex-start">
              <Typography
                fontWeight="600"
                fontSize={{ xs: "12px", md: "14px" }}
              >
                {t("Order")}
                <Typography
                  fontWeight="600"
                  component="span"
                  marginLeft="5px"
                  fontSize={{ xs: "12px", md: "14px" }}
                >
                  {"#"}
                  {order?.id}
                </Typography>
                <Typography component="span" marginLeft="5px" fontSize="12px">
                   { order?.order_type !== "parcel" &&  `( ${order?.details_count} ${t("Items")} )` }
                </Typography>
              </Typography>
              {order?.order_status === "delivered" ? (
                <OrderStatusTypography color={color}>
                  {t("Delivered")}
                </OrderStatusTypography>
              ) : (
                <OrderStatusTypography color={color}>
                  {order?.order_status === "failed"
                    ? t("Payment Failed")
                    : t(order?.order_status).replaceAll("_", " ")}
                </OrderStatusTypography>
              )}
              <DateTypography>
                {order?.order_status === "delivered" ? (
                  <CustomFormatedDateTime date={order?.delivered} />
                ) : (
                  <CustomFormatedDateTime date={order?.created_at} />
                )}
              </DateTypography>
            </Stack>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              justifyContent={{ xs: "flex-start", sm: "space-between" }}
              alignItems={{ xs: "flex-start", sm: "center" }}
              spacing={{ xs: 1, sm: 2 }}
              width={{ xs: "100%", md: "auto" }}
              sx={{
                marginTop: { xs: "8px", sm: "0px" },
                minWidth: { sm: "200px" }
              }}
            >
              <Typography
                fontSize={{ xs: "14px", sm: "16px" }}
                fontWeight="600"
                color="primary.main"
                textAlign="left"
              >
                {getAmountWithSign(order?.order_amount)}
              </Typography>
              <Stack direction="row" spacing={1} flexWrap="wrap">
                {order?.order_status == "delivered"
                  ? deliveredInformation()
                  : notDeliveredInformation()}
              </Stack>
            </Stack>
          </CustomStackFullWidth>
        </Grid>
      </Grid>
      {sideDrawerOpen && (
        <TrackParcelOrderDrawer
          orderId={order?.id}
          sideDrawerOpen={sideDrawerOpen}
          setSideDrawerOpen={setSideDrawerOpen}
          closeHandler={() => setSideDrawerOpen(false)}
        />
      )}
      {trackOrderDrawerOpen && (
        <TrackOrderDrawer
          orderId={order?.id}
          sideDrawerOpen={trackOrderDrawerOpen}
          setSideDrawerOpen={setTrackOrderDrawerOpen}
          closeHandler={() => setTrackOrderDrawerOpen(false)}
        />
      )}
    </CustomPaper>
  );
};
Order.propTypes = {};

export default Order;
